var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10625_96064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6363 9.28114H14.4358C14.2689 9.28114 14.1244 9.16626 14.0857 9.00388C13.7209 7.47462 12.5121 6.26962 10.9807 5.91021C10.8177 5.87193 10.7021 5.72724 10.7021 5.55982V0.361236C10.7021 0.146549 10.8887 -0.019544 11.1021 0.00303403C13.3737 0.243776 15.4787 1.24459 17.117 2.88248C18.7507 4.51658 19.7508 6.61552 19.9945 8.88063C20.0174 9.09431 19.8512 9.28114 19.6363 9.28114Z",
    fill: "#FF7258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7021 5.55949V4.48926C13.2058 4.79859 15.1916 6.77945 15.5086 9.28085H14.4358C14.2689 9.28085 14.1244 9.16597 14.0857 9.00358C13.7209 7.47433 12.5121 6.26933 10.9808 5.90992C10.8177 5.87164 10.7021 5.72691 10.7021 5.55949Z",
    fill: "#F95D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9982 11.0314C19.7979 12.9504 19.0551 14.751 17.8445 16.252C17.7095 16.4192 17.4599 16.4339 17.308 16.282L14.3965 13.3705L13.6304 12.6044C13.5119 12.4858 13.4918 12.3018 13.5799 12.1591C13.8144 11.7794 13.9897 11.3595 14.0929 10.9122C14.1307 10.7484 14.2756 10.6318 14.4438 10.6318H19.64C19.8545 10.6318 20.0205 10.818 19.9982 11.0314Z",
    fill: "#FFDC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5155 10.6318C15.3961 11.6562 14.9972 12.5951 14.3965 13.3705L13.6304 12.6044C13.5119 12.4859 13.4918 12.3018 13.5799 12.1591C13.8144 11.7795 13.9897 11.3595 14.0929 10.9122C14.1307 10.7484 14.2756 10.6319 14.4438 10.6319H15.5155V10.6318Z",
    fill: "#FFC846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3543 17.2392C16.506 17.391 16.4917 17.6401 16.325 17.7751C14.5469 19.2158 12.3473 19.9994 10.0267 19.9994C7.34883 19.9994 4.83083 18.9561 2.93685 17.0626C1.05357 15.1794 0.0118156 12.6791 9.6881e-05 10.0182C-0.0116609 7.34586 1.04724 4.77208 2.93689 2.88247C4.57493 1.24443 6.68016 0.243608 8.95207 0.00302276C9.16524 -0.0195163 9.35125 0.147007 9.35125 0.361342V5.55985C9.35125 5.72758 9.2352 5.87211 9.07188 5.91047C7.22954 6.34328 5.8538 8 5.8538 9.97281C5.8538 12.2734 7.72567 14.1457 10.0266 14.1457C10.8357 14.1457 11.5914 13.914 12.2316 13.5139C12.3744 13.4247 12.5594 13.4444 12.6784 13.5635L16.3543 17.2392Z",
    fill: "#00ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6789 13.5629L13.4466 14.3306C12.5039 15.0751 11.3125 15.52 10.0175 15.5203C6.95041 15.5209 4.48764 13.0656 4.47951 9.99855C4.47193 7.15898 6.60224 4.81516 9.35169 4.48633V5.55926C9.35169 5.72699 9.23564 5.87152 9.07235 5.90988C7.23001 6.34269 5.85427 7.99941 5.85427 9.97222C5.85427 12.2728 7.72615 14.1451 10.0271 14.1451C10.8361 14.1451 11.5919 13.9134 12.2321 13.5133C12.3748 13.4241 12.5598 13.4439 12.6789 13.5629Z",
    fill: "#099DD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10625_96064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/Pie_chart.d1f62decc343b2e0e4fbfb77096c7139.svg";
export { ForwardRef as ReactComponent };